"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ConfigureView;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ConfigureView(_ref) {
  var relevantFieldsConfig = _ref.relevantFieldsConfig,
      onSaveAndExitClick = _ref.onSaveAndExitClick,
      onCancel = _ref.onCancel;

  var _useState = (0, _react.useState)(JSON.stringify(relevantFieldsConfig, null, 4)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      relevantFieldsInputValue = _useState2[0],
      setRelevantFieldsInputValue = _useState2[1];

  var parseConfigAndDoSaveAndExit = function parseConfigAndDoSaveAndExit() {
    var configAsObj;

    try {
      configAsObj = JSON.parse(relevantFieldsInputValue);
      onSaveAndExitClick(configAsObj);
    } catch (err) {
      console.error('Error while parsing config:', err);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: parseConfigAndDoSaveAndExit
  }, "Save & Exit"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onCancel
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement("h2", {
    style: {
      textAlign: 'center'
    }
  }, "Configure"), /*#__PURE__*/_react["default"].createElement("label", null, "Relevant Fields:", /*#__PURE__*/_react["default"].createElement("textarea", {
    style: {
      width: '95%',
      marginLeft: '2.5%',
      height: '70%'
    },
    value: relevantFieldsInputValue // Update the value of the input on every change, so that the user can really type it in
    // We'll call setRelevantFieldConfig before we exit, because that's when our EADebugPanel really needs to know about it
    ,
    onChange: function onChange(e) {
      return setRelevantFieldsInputValue(e.target.value);
    }
  })));
}